<script lang="ts">
	import { format } from 'svelte-i18n';
	import { Text, Container, Input } from '@Shelly/shelly-design-system';
	import { capFirstChar, _deepClone } from '../../../../helpers/utilities';
	import type { ITempSchemeObj } from '../../../../types/TemperatureSchemeType';

	export let temp_scheme_object: ITempSchemeObj;

	let inputDirty = false;

	const onInput = (e) => {
		if (!inputDirty) inputDirty = true;
		temp_scheme_object._meta.name = e?.target?.value;
	};
</script>

<Container padding="scrollPaddings">
	<Text element="h2" class="mb-s">
		{capFirstChar(
			$format('placeholder_name', {
				values: { type: $format('process_thermostat') },
			}),
		)}
	</Text>
	<!-- DO NOT REMOVE COMMENT: Padding references -->
	<Input
		class="pb-s"
		icon="fas fa-temperature-half"
		size="m"
		label={$format('label_name', { default: 'name' })}
		value={temp_scheme_object?._meta?.name}
		error={temp_scheme_object?._meta?.name === '' && inputDirty
			? $format('input_error_empty_name', {
					default: ' Name cannot be empty',
				})
			: ''}
		on:input={onInput}
		id="input-cmx8mdf"
		aria-labelledby="input-cmx8mdf"
	/>
</Container>
